import { routerReducer } from 'react-router-redux';
import { combineReducers } from 'redux';
import { vkReducer } from "./vk/reducers";
import { globals } from "./globals/reducers";
import { logger } from "./logger/reducers";
import { bills } from "./bills/reducers";
import { cashier } from "./cashier/reducers";
import { modal } from "./modal/reducers";


export const rootReducer = combineReducers({
    router: routerReducer,
    vk: vkReducer,
    globals: globals,
    logger: logger,
    bills: bills,
    cashier: cashier,
    modal: modal,
});


// WEBPACK FOOTER //
// ./src/js/store/reducers.js